// Source: https://rudrastyh.com/api/instagram-with-pure-javascript.html & https://humaan.com/blog/bigger-square-thumbnails-from-the-instagram-api/

import { formatDistance } from 'date-fns';
import { nl } from 'date-fns/esm/locale';
import modals from 'Modals';
modals.init();

function getJSON(url, callback) {
    var xhr = new XMLHttpRequest();
    xhr.open("GET", url, true);
    xhr.onload = function (e) {
        if (xhr.readyState === 4) {
            if (xhr.status === 200) {
                var res = xhr.responseText;
                callback(JSON.parse(res));
            } else { 
                console.error(xhr.statusText);
            }
        }
    }; 

    xhr.onerror = function (e) {
      console.error(xhr.statusText);
    }; 

    xhr.send(null);
}


// Blitskikker: 4639563558.8183fb1.8adf9445e6944d40b18fcf9af27aa034
let token = 'IGQVJWRnc2bmpuQUxsYTdwYjFMaGpLMHlqZAnlGb0QtV0Y3TGNUVzdEYTRDUDhjRTRwRXNYYWhFanBlYTcweE1rZAnpWSmgxbUhWZAVdxd2ZAqLWdHdlZAoOWwwQnlpOUdWWU5SV2haRnRSbmVFVjhoS2ZAvMgZDZD',
    numPhotos = 4, // maximum 20
    container = document.querySelector('.js-insta'),
    scrElement = document.createElement('script');

window.processResult = function (data) {

        var options = {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        }

    for (let i = 0; i < numPhotos; i++) {

        let x = i;


        // set variables
        let d = new Date(data.data[x].timestamp),
            src = data.data[x].media_url,
            date = new Date(d).toLocaleString('en-GB', options),
            fullCaption = data.data[x].caption,
            caption = '';
        
        if (fullCaption) { caption = fullCaption.substring(0, 320) + '...' };

        let type = data.data[x].media_type;
        if (type == 'VIDEO') {
            src = data.data[x].thumbnail_url;
        }

        let id = data.data[x].id;
        let link = data.data[x].permalink;

        // set HTML
        container.innerHTML += `
            <li class="instagram__item black">
                <a data-modal="#insta_${id}" href="">
                    <img class="instagram__img" src="${src}">
                </a>
                <div class="instagram__info modal" data-modal-window id="insta_${id}">
                    <div class="modal__img">
                        <img src="${src}">
                    </div>
                    <div class="modal__content">
                        <a class="close" data-modal-close href="#">
                            <svg viewbox="0 0 40 40"><path class="close-x" d="M 10,10 L 30,30 M 30,10 L 10,30" /></svg>
                        </a>
                        <p class="instagram__text">${caption}</p>
                        <p class="instagram__date">${date}</p>
                    </div>
                </div>
            </li>`
            ;
    }
};

if (container) {
  getJSON('/instafeed', function(data) {processResult(data) });
}


// if (container) {
//     scrElement.setAttribute('src', 'https://graph.instagram.com/me/media?fields=username,media_url,thumbnail_url,media_type,permalink,timestamp,caption,like_count&access_token=' + token + '&count=' + numPhotos + '&callback=mishaProcessResult');
//     document.body.appendChild(scrElement);
// }